require('./dist/angular-flash');
module.exports = 'ngFlash';



//////////////////
// WEBPACK FOOTER
// ../~/angular-flash-alert/index.js
// module id = 113
// module chunks = 3